import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { Color } from "../../theme/Color";
import { DropShadowBlack, RoundedCorners } from "../../theme/Mixins";
import CardTitle from "./CardTitle";

type CardProps = React.PropsWithChildren<{
  title?: string;
  titleIsCentered?: boolean;
  icon?: IconDefinition;
  hasPadding?: boolean;
  style?: any;
  hideBorders?: boolean;
  contentIsCentered?: boolean;
}>;

const StyledCardRow = styled(Row)<{
  hasPadding: boolean;
  hideBorders: boolean;
}>`
  background: ${Color.White};
  margin: 1rem 1rem 2rem 1rem;
  padding: ${({ hasPadding }) => (hasPadding ? "2rem" : "0")};
  ${({ hideBorders }) => (hideBorders ? null : DropShadowBlack)};
  ${RoundedCorners};
`;

const Card = ({
  title,
  titleIsCentered = false,
  icon,
  hasPadding = false,
  hideBorders = false,
  contentIsCentered = false,
  children,
  ...props
}: CardProps) => {
  return (
    <StyledCardRow hasPadding={hasPadding} hideBorders={hideBorders} {...props}>
      <Col xs={12}>
        {title && (
          <CardTitle title={title} centered={titleIsCentered} icon={icon} />
        )}
        <Row center={contentIsCentered ? "xs" : undefined}>{children}</Row>
      </Col>
    </StyledCardRow>
  );
};

export default Card;
